<template>
    <div class="School">
        
        <div class="row record-section-row">
            <div class="col">
                <h4>School Enrollments:</h4>
                <SchoolDisplayAndEdit  
                                      :edit-mode="EditMode"
                                      :global-update="true"
                                      get-endpoint="Residential/Clients/GetSchoolMemberships"
                                      :get-payload="{Id: ChildRecordData.Id }"
                                      add-edit-endpoint="Residential/Clients/AddOrUpdateSchoolMembership"
                                      :add-edit-payload="{ClientSubProgramMembershipID: ChildRecordData.Id}"
                                      delete-endpoint="Residential/Clients/DeleteSchoolMembership"
                                      :delete-payload="{Id: ChildRecordData.Id}" 
                                      :common-schools="CommonSchools" />
            </div>
        </div>
        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode"/>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    import SchoolDisplayAndEdit from '../../../Core/ItemEditors/SchoolDisplayAndEdit';
    import EditMode from '../../../Core/ItemEditors/EditMode.vue';
    export default {
        props: [
            'ChildRecordData'
        ],
        data: function () {
            return {
                EditMode: false
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            }
        },
        components: {
            SchoolDisplayAndEdit,
            EditMode
        },
        mounted() {

        },
        computed: {
            CommonSchools: function () {
                return this.$store.getters["Schools.CommonSchools"](this.ChildRecordData.SubProgramID);
            },
        }    
    }
</script>

<style scoped>
</style>